import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import AFWhitelistList from './containers/AfWhitelistList';
import AfWhitelistCreate from './containers/AfWhitelistCreate';
import AfWhitelistEdit from './containers/AfWhitelistEdit';
import AfWhitelistView from './containers/AfWhitelistView';
import { SYSTEM_CONFIGURATION_ROUTE, AFWHITELIST, SYSTEM } from '../../constants';

interface Props {
}

const AfWhitelist: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${AFWHITELIST}`}>
        <AFWhitelistList />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${AFWHITELIST}/create`}>
        <AfWhitelistCreate />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${AFWHITELIST}/edit`}>
        <AfWhitelistEdit />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${AFWHITELIST}/view`}>
        <AfWhitelistView />
      </Route>
    </Fragment>
  );
};

export default AfWhitelist;
